import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ACTIVITY_ENDPOINT = `${API_BASE_URL.replace(/\/$/, '')}/activity/navigation`;

const getUserId = (user) => user?.userId || user?.id || '';

const getUserName = (user) => user?.email || user?.userName || user?.username || user?.displayName || '';
const getMainPageName = (pathname) => {
    if (!pathname) return '';

    const mainSegment = pathname.split('/').filter(Boolean)[0];
    return mainSegment || 'dashboard';
};

export const postNavigationActivity = async ({
    user,
    pathname,
    actionType = '',
    actionDetails,
}) => {
    const userId = getUserId(user);
    const userName = getUserName(user);

    if (!userId || !userName || !pathname) return;

    const payload = {
        userId,
        userName,
        actionName: getMainPageName(pathname),
        ActionType: actionType,
        ActionDetails: actionDetails || '',
    };

    try {
        await axios.post(ACTIVITY_ENDPOINT, payload);
    } catch (error) {
        console.error('Failed to post navigation activity', error);
    }
};

